// extracted by mini-css-extract-plugin
export default {"followingUsersTitle":"IOzR9bBDJB9GE187ghK3","followingUserName":"NIsftPidKMTVm44IQj4C","followingUserImage":"kC6tElLAbkYaukFaGqpw"};